import React, { useState, useEffect } from 'react';
import MimeEmailViewer from './MimeEmailViewer';
import useAxiosPrivate from "@/hooks/useAxiosPrivate";

interface EmailContentProps {
  orderId: string;
}

interface EmailData {
  raw: string;
}

const EmailContent = ({ orderId }: EmailContentProps) => {
  const axiosPrivate = useAxiosPrivate();
  const [loading, setLoading] = useState<boolean>(false);
  const [emailData, setEmailData] = useState<EmailData | null>(null);
  
  useEffect(() => {
    const fetchRawEmail = async (): Promise<void> => {
      setLoading(true);
      try {
        const response = await axiosPrivate.get<EmailData>(
          `/orders/${orderId}/emailRaw`
        );
        console.log('Raw email response:', response);
        setEmailData(response.data);
      } catch (error) {
        console.error(
          "Erreur lors de la récupération du raw email:",
          error
        );
      } finally {
        setLoading(false);
      }
    };
    
    if (orderId) {
      fetchRawEmail();
    }
  }, [orderId, axiosPrivate]); 
  
  const renderEmailContent = () => {
    if (loading) {
      return <div>Chargement de l'email...</div>;
    }
    
    if (emailData) {
      return <MimeEmailViewer emailData={emailData} />;
    }
    
    return (
      <div className="whitespace-pre-wrap">
        Contenu de l'email non disponible
      </div>
    );
  };
  
  return (
    <div className="w-full">
      {renderEmailContent()}
    </div>
  );
};

export default EmailContent;